import React from 'react'
import { graphql } from 'gatsby'
import { getSrc } from 'gatsby-plugin-image'
import AcfBuilder from '../components/ACF/AcfBuilder'
import SEO from '../components/SEO/SEO'
import Layout from '../containers/Layout'

const PageTemplate = (props) => {
    const {
        data: {
            wpPage: {
                acfFlexibleFields,
                acfHidePageHeaderFooter: { hideHeaderAndFooter },
                cleanTitle,
                date,
                featuredImage,
                modified,
                seo,
            },
        },
        path,
    } = props

    const facebookImage = getSrc(featuredImage?.node?.facebook)
    const twitterImage = getSrc(featuredImage?.node?.twitter)

    return (
        <Layout
            hideFooter={hideHeaderAndFooter}
            hideHeader={hideHeaderAndFooter}
        >
            <SEO
                dateModified={modified}
                datePublished={date}
                description={seo.metaDesc}
                facebookPostImage={facebookImage}
                postType="page"
                title={cleanTitle}
                twitterPostImage={twitterImage}
                url={path}
                yoastTitle={seo.title}
            />
            <AcfBuilder data={acfFlexibleFields.flexibleFields} />
        </Layout>
    )
}

export const pageQuery = graphql`
    query page($id: String!) {
        wpPage(id: { eq: $id }) {
            title
            cleanTitle
            content
            featuredImage {
                node {
                    ...Facebook
                    ...Twitter
                }
            }
            acfFlexibleFields {
                flexibleFields {
                    ...AcfCtaBanner
                    ...AcfCtaBanner
                    ...AcfHeroBanner
                    ...AcfImageContent
                    ...AcfWysiwyg
                    ... on WpPage_Acfflexiblefields_FlexibleFields_InvoiceBuilder {
                        fieldGroupName
                    }
                }
            }
            acfHidePageHeaderFooter {
                hideHeaderAndFooter
            }
            seo {
                metaDesc
                metaKeywords
                metaRobotsNofollow
                metaRobotsNoindex
                opengraphDescription
                opengraphTitle
                title
                twitterDescription
                twitterTitle
            }
        }
    }
`

export default PageTemplate
